export type OnboardingStepId =
  | 'investingStyle'
  | 'companies'
  | 'signals'
  | 'themes'
  | 'popularSearches';

export type InvestingStyleId =
  | 'growth'
  | 'value'
  | 'steady_compounder'
  | 'dividend'
  | 'founder_led';

export interface OnboardingPreferences {
  signals?: string[];
  /** Screener clauses for selected signals (AND'd together for match counts). */
  signalQueries?: string[];
  themes?: string[];
  popularSearches?: string[];
  investingStyle?: InvestingStyleId[];
  /** Screener clauses for selected investing styles, keyed by style id. */
  investingStyleQueries?: Partial<Record<InvestingStyleId, string[]>>;
  skippedSteps?: OnboardingStepId[];
  onboardingFlowVersion?: number;
}

export const INVESTING_STYLE_IDS: InvestingStyleId[] = [
  'growth',
  'steady_compounder',
  'value',
  'dividend',
  'founder_led',
];
